<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-alert type="warning">
            {{ $lang('main.works.not_available') }}
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
  export default {
    name: "CompanySubscriptionPayPal"
  }
</script>

<style scoped>

</style>
